module.exports = __webpack_public_path__ + "img/presale-detail11.e630c9d0.png";